import { useEffect, useState } from "react";
import "../../components/css/bootstrap.min.css";
import "font-awesome/css/font-awesome.min.css";
import Qtest from "../../services/Qtest";
import AccessibilityModal from "../../components/common/modals/AccessibilityModal";
import ErrorMessage from "../../components/common/ErrorMessage";
import AccessibilityConformancePercentChart from "../../components/charts/defects/accessibility/AccessibilityConformancePercentChart";

export default function Accessibility({ token, currentProjectId, iterations }) {
  const [showModal, setShowModal] = useState(false);

  const [loading, setLoading] = useState(false);

  const [errorMessage, setErrorMessage] = useState(null);

  const [modalData, setModalData] = useState({
    title: "",
    rows: [],
  });

  const [currentIteration, setCurrentIteration] = useState("Overall");

  const [
    qtestAccessibilityExecutionTypeResponse,
    setQtestAccessibilityExecutionTypeResponse,
  ] = useState(null);

  const [testCasesDetails, setTestCasesDetails] = useState(null);

  async function fetchAccessibilityMetrics() {
    setLoading(true);
    const response = await Qtest.getAccessibilityConformance(
      token,
      currentProjectId
    );

    if (response.message) {
      setErrorMessage(response.message);
    } else {
      setQtestAccessibilityExecutionTypeResponse(
        response.qtestAccessibilityExecutionTypeResponse
      );
      setTestCasesDetails(response.testCasesDetails);
    }

    setLoading(false);
  }

  const handleIterationClick = (event) => {
    setCurrentIteration(event.target.id);
  };

  useEffect(() => {
    fetchAccessibilityMetrics();
  }, []);

  return (
    <div>
      <AccessibilityModal
        isOpen={showModal}
        setShowModal={setShowModal}
        data={modalData}
      />
      <ErrorMessage errorMessage={errorMessage} />
      {errorMessage === null && (
        <>
          <div id="sprints-container">
            {loading && (
              <div className="d-flex justify-content-center bg-transparent ">
                <div className="spinner-border" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            )}
            {!loading && (
              <>
                <div id="main_container_1" className="bg-light">
                  <AccessibilityConformancePercentChart
                    qtestAccessibilityExecutionTypeResponse={
                      qtestAccessibilityExecutionTypeResponse
                    }
                    testCasesDetails={testCasesDetails}
                    currentIteration={currentIteration}
                    setModalData={setModalData}
                    setShowModal={setShowModal}
                  />
                </div>
              </>
            )}
          </div>
        </>
      )}
    </div>
  );
}
